import React, { useEffect } from 'react';
import { BgisModal, BgisModalHeader, BgisModalFooter, BgisModalBody } from './bgis/components/modal';
import { BgisButtonIcon } from './bgis/components/icon';
import { useAppDispatch, useAppSelector } from './beat/hooks';
import { tearDownMap } from './beat/redux/slice/mapSlice';
import { WebGis } from './beat/components/WebGis';
import { mapState } from './beat/map';
import uLogo  from './img/logo/umweltbundesamt_logo.png';
interface AppProps {
}

export const App: React.FC<AppProps> = () => {

  const dispatch = useAppDispatch();

  const tearDown = () => {
      dispatch(tearDownMap());
 
      window.close();
      //window.location.href="https://www.umweltbundesamt.at/umweltthemen/uvpsup/beat-karte";
    
  }

  

  return (<BgisModal>
    <BgisModalHeader>
        <span className="bgis-grow">BEAT Karte - Wertvolle landwirtschaftliche Produktionsflächen (aus dem Projekt „<b>B</b>odenbedarf für die <b>E</b>rnährungssicherung in <b>AT</b>)</span>
        <span style={{borderRight:'solid 1px black', paddingRight:'1rem', marginRight:'1rem'}}><img src={uLogo} style={{maxWidth: '200px'}}/></span>
        <BgisButtonIcon iconName='bgis-icon-times' onClick={tearDown}></BgisButtonIcon>
    </BgisModalHeader>
    <BgisModalBody>
      <WebGis map={mapState.h2oMap} ></WebGis>
    </BgisModalBody>
    <BgisModalFooter>
        <button className='bgis-button' onClick={tearDown}>Abbrechen</button>    
     </BgisModalFooter>
  </BgisModal>);
}